import { Spin } from 'antd';

const LoadingSpinner = ({ tip = 'Loading...' }) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: '#f5f5f5',
    }}>
      <Spin size="large" description={tip}>
        <div style={{ padding: 50 }} />
      </Spin>
    </div>
  );
};

export default LoadingSpinner;
